module.exports = __webpack_public_path__ + "static/blog-02-e2a427ba044926de8bdd146ec46dcf0b.jpg";